import { createSlice } from "@reduxjs/toolkit";

// Global open/close flag for DocumentPreviewModal (see components/policy/DocumentPreviewModal.jsx),
// rendered once via GlobalDocumentPreviewModal so "Review & Update" — from the Issues Detected
// modal or the Policy Intelligence Score card — opens it regardless of the active route.
const documentPreviewModalSlice = createSlice({
  name: "documentPreviewModal",
  initialState: {
    isOpen: false,
  },
  reducers: {
    openDocumentPreviewModal: state => {
      state.isOpen = true;
    },
    closeDocumentPreviewModal: state => {
      state.isOpen = false;
    },
  },
});

export const { openDocumentPreviewModal, closeDocumentPreviewModal } = documentPreviewModalSlice.actions;

export default documentPreviewModalSlice.reducer;
